module.exports = __webpack_public_path__ + "static/media/add.7be89c96.svg";